import { For } from "solid-js";

// Petites icônes en ligne, toutes au trait, aucune pleine (POC). Les Paramètres
// portent des curseurs et non un engrenage : à 14 px les dents d'une roue se
// brouillent, et l'onglet contient littéralement des curseurs.
const CHEMINS = {
  reglages: [
    "M3 6h11M18 6h3M3 12h4M11 12h10M3 18h12M19 18h2",
    "M16 6a2 2 0 1 0-4 0 2 2 0 0 0 4 0",
    "M9 12a2 2 0 1 0-4 0 2 2 0 0 0 4 0",
    "M17 18a2 2 0 1 0-4 0 2 2 0 0 0 4 0",
  ],
  bulle: ["M4 5h16v11H9l-5 4z"],
  // Les vues : un réseau, une arborescence, une grille de pastilles, des barres.
  reseau: [
    "M8.5 7a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0z",
    "M20.5 6a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0z",
    "M14.5 18a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0z",
    "M8.4 6.8l7.1-.6M7.2 9.2l3.6 6.6M16.9 8.3l-3.7 7.4",
  ],
  arbre: [
    "M9.5 3h5v4h-5z",
    "M3 16h5v4H3zM9.5 16h5v4h-5zM16 16h5v4h-5z",
    "M12 7v4.5M5.5 16v-4.5h13V16M12 11.5V16",
  ],
  grille: [
    "M7.4 6a1.4 1.4 0 1 1-2.8 0 1.4 1.4 0 0 1 2.8 0z",
    "M13.4 6a1.4 1.4 0 1 1-2.8 0 1.4 1.4 0 0 1 2.8 0z",
    "M19.4 6a1.4 1.4 0 1 1-2.8 0 1.4 1.4 0 0 1 2.8 0z",
    "M7.4 12a1.4 1.4 0 1 1-2.8 0 1.4 1.4 0 0 1 2.8 0z",
    "M13.4 12a1.4 1.4 0 1 1-2.8 0 1.4 1.4 0 0 1 2.8 0z",
    "M19.4 12a1.4 1.4 0 1 1-2.8 0 1.4 1.4 0 0 1 2.8 0z",
    "M7.4 18a1.4 1.4 0 1 1-2.8 0 1.4 1.4 0 0 1 2.8 0z",
    "M13.4 18a1.4 1.4 0 1 1-2.8 0 1.4 1.4 0 0 1 2.8 0z",
    "M19.4 18a1.4 1.4 0 1 1-2.8 0 1.4 1.4 0 0 1 2.8 0z",
  ],
  graphiques: ["M4 20h16", "M7 17v-6M12 17V5M17 17V9"],
  liste: ["M9 6h11M9 12h11M9 18h11", "M4.5 6h.01M4.5 12h.01M4.5 18h.01"],
  // Les outils.
  loupe: ["M10.5 17a6.5 6.5 0 1 0 0-13 6.5 6.5 0 0 0 0 13z", "M20 20l-4.8-4.8"],
  recadrer: ["M4 9V4h5M15 4h5v5M20 15v5h-5M9 20H4v-5"],
  telecharger: ["M12 4v11", "M7.5 10.5L12 15l4.5-4.5", "M5 20h14"],
  deplier: ["M7 6l5 5 5-5", "M7 13l5 5 5-5"],
  filtre: ["M4 5h16l-6 7.5V19l-4-2v-4.5z"],
  effacer: ["M6 6l12 12M18 6L6 18"],
  lien: [
    "M10 14a4.5 4.5 0 0 0 6.4 0l3-3a4.5 4.5 0 0 0-6.4-6.4l-1 1",
    "M14 10a4.5 4.5 0 0 0-6.4 0l-3 3a4.5 4.5 0 0 0 6.4 6.4l1-1",
  ],
  coche: ["M5 12.5l4.5 4.5L19 7.5"],
  replier: ["M7 11l5-5 5 5", "M7 18l5-5 5 5"],
  // Les rubriques des filtres.
  insecte: [
    "M12 8a3 3 0 0 1 3 3v3a3 3 0 0 1-6 0v-3a3 3 0 0 1 3-3z",
    "M10.5 8.4L9 5.5M13.5 8.4L15 5.5",
    "M9 11.5H5M15 11.5h4M9 15l-3.5 2M15 15l3.5 2",
  ],
  levier: ["M13 3L5 13.5h6L10 21l8-10.5h-6z"],
  feuille: ["M5 19C5 11 11 5 19 5c0 8-6 14-14 14z", "M5 19l7.5-7.5"],
  personnes: [
    "M9 11a3 3 0 1 0 0-6 3 3 0 0 0 0 6z",
    "M3.5 19.5a5.5 5.5 0 0 1 11 0",
    "M15.5 5.2a3 3 0 0 1 0 5.6M17 14a5.5 5.5 0 0 1 3.5 5.5",
  ],
  horloge: ["M12 20a8 8 0 1 0 0-16 8 8 0 0 0 0 16z", "M12 8v4l3 2"],
  // Union et intersection dessinées : en caractères, elles tombent sur une police
  // de secours et n'ont pas la même graisse.
  union: ["M6.5 5v7a5.5 5.5 0 0 0 11 0V5"],
  intersection: ["M6.5 19v-7a5.5 5.5 0 0 1 11 0v7"],
} as const;

export type NomIcone = keyof typeof CHEMINS;

export function Icone(props: { nom: NomIcone }) {
  return (
    <svg class="icone" viewBox="0 0 24 24" aria-hidden="true">
      <For each={CHEMINS[props.nom]}>{(d) => <path d={d} />}</For>
    </svg>
  );
}
